import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * interfaces
 */
import { IRega } from 'src/app/core/interfaces/ads/rega';
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

@Component({
  selector: 'app-advertisement-extra-details',
  templateUrl: './advertisement-extra-details.component.html',
  styleUrls: ['./advertisement-extra-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvertisementExtraDetailsComponent {

  /************  Inputs  ************/
  /**
   * data
   * @description Advertisement Data
   */
  @Input({ alias: 'advertisementData', required: true }) public AdvertisementData: IAdvertisementResponse = null;   

  /**
   * regaData
   * @description rega Data
   */
  @Input({ alias: 'regaAdvertisementData', required: true }) public RegaAdvertisementData: IRega = null;  
  
  /************  Fields  ************/
  /**
   * IsExtraDetailsCollapsed
   */
  public IsExtraDetailsCollapsed: boolean = false;


  /**
   *
   */
  constructor() {}

  /************  Methods  ************/
  /**
   * IsExtraDetailsCollapsed
   * @description show or hide Extra Details
   */
  public ToggleExtraDetailsCollapse(): void {
    this.IsExtraDetailsCollapsed = !this.IsExtraDetailsCollapsed
  }

}
